import { useWhyTakeCourse } from './useWhyTakeCourse';
import CustomAccordion from '../../Molecules/CustomAccordion/CustomAccordion';
import Spinner from '../Spinner/Spinner';
import { STAY_KEYS } from '../../../Domain/Settings/Constants/Constants';
import TitleYellow from '../TitleYellow/TitleYellow';

export const WhyTakeCourse = (props) => {
  const parameters = props?.parameters;

  const { about } = useWhyTakeCourse({
  language: props.language
  });
  const items = about;

  const getTitle = (key) => {
    switch (key) {
      case STAY_KEYS.COURSE_DETAIL:
        return parameters?.INF_MSG_69;
      default:
        return parameters?.INF_MSG_69;
    }
  };

  return (
    <section className="wrapper-portfolio">
      <div className="container pt-5 pb-3 justify-content-center ps-lg-0 px-md-0 px-3">
        <TitleYellow
          className="text-center text-white"
          title={getTitle(props.pageStay)?.value}
          titleYellow={getTitle(props.pageStay)?.description_value}
        />
        <div aria-label="contain section">
          <CustomAccordion parameters={parameters} items={items} />
        </div>
      </div>
    </section>
  );
};
